import { IconArrowLeftSmall } from 'ui/icons';
import { IconChevronSmallLeft } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { List, ListItem } from 'omakase';
import { siteMenuBackButtonContainer } from 'omakase/SiteMenu/siteMenuCssDefs';
import React from 'react';

export interface SiteMenuBackButtonProps {
  onClickBackButton(): void;
  text?: string;
  id?: string;
}

const SiteMenuBackButton: React.FunctionComponent<SiteMenuBackButtonProps> = ({
  onClickBackButton,
  text = 'Back',
  id,
}) => {
  return (
    <div css={siteMenuBackButtonContainer}>
      <List>
        <ListItem
          component="button"
          elementStart={
            <IconMigrationUtil
              legacyIcon={<IconArrowLeftSmall />}
              newIcon={<IconChevronSmallLeft />}
            />
          }
          onClick={onClickBackButton}
          size="medium"
          slimLeft={true}
          variant="basic"
          weight="book"
          id={id}
        >
          {text}
        </ListItem>
      </List>
    </div>
  );
};

export default SiteMenuBackButton;
